export default __webpack_public_path__ + "static/media/more-gray.857b9cfa.svg";